<template>
    <div class="webcamOptions">
        <a class="btn btn-primary dropdown-toggle btn-sm" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{__('webcam.options')}}
        </a>

        <template v-if="profile">
        <div class="dropdown-menu dropdown-menu-right p-2" aria-labelledby="dropdownMenuLink" id="webcamOptionsMenu">
            <h5>{{__('webcam.webcam_view')}}</h5>
            <a class="dropdown-item" href="#" @change.stop="updateWebCamOptions()" v-for="option in webcamDisplayOptions" :key="option.id">
                <input v-model="displayOption" type="radio" :id="option.id" :value="option.id">
                <label :for="option.id">{{option.name}}</label>
            </a>
            <div class="dropdown-divider"></div>
            <h5>{{__('webcam.labels')}}</h5>
            <a class="dropdown-item" href="#"><input @change.stop="updateWebCamOptions()" v-model="displayStreamId" type="checkbox" id="streamIdCheckbox"> <label for="streamIdCheckbox">{{__('webcam.show_stream_id')}}</label></a>
            <a class="dropdown-item" href="#"><input @change.stop="updateWebCamOptions()" v-model="displayStreamName" type="checkbox" checked id="streamNameCheckbox">  <label for="streamNameCheckbox">{{__('webcam.show_stream_name')}}</label></a>
            <div class="dropdown-divider"></div>
            <p v-html="__('webcam.webcam_option_text')"></p>
        </div>
        </template>
        <template v-else>
           <div class="dropdown-menu dropdown-menu-right p-2" aria-labelledby="dropdownMenuLink" id="webcamOptionsMenu">
               <p v-html="__('webcam.webcam_boardprofile_text')"></p>
           </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                webcamDisplayOptions: [
                    {id: 'webcamDisplayAllCameras', name: __('webcam.all_webcams')},
                    {id: 'webcamDisplayActivePlayer', name: __('webcam.active_player')},
                    {id: 'webcamDisplayOnlyOpponent', name: __('webcam.only_opponent')},
                    {id: 'webcamDisplayOnlyOwnCameras', name: __('webcam.only_own_cameras')},
                    {id: 'webcamDisplayOnlyPlayer1', name: __('webcam.only_player1')},
                    {id: 'webcamDisplayOnlyPlayer2', name: __('webcam.only_player2')},
                    {id: 'webcamDisplayHideAll', name: __('webcam.hide_cameras')}
                ],
                displayOption: 'webcamDisplayAllCameras',
                displayStreamId: true,
                displayStreamName: true,
                profile: null
            }
        },
        mounted() {
            $("#webcamOptionsMenu").on('click', function(e){
                e.stopPropagation();
            })
            this.$root.$emit('ProfileSelectorAddObserver', this.loadProfile)
        },
        methods: {
            loadProfile(profile) {
                this.profile = profile;
                if (this.profile) {
                    if (this.profile.webcamDisplayOption) this.displayOption = this.profile.webcamDisplayOption;
                    if (this.profile.webcamDisplayStreamId !== null) this.displayStreamId = this.profile.webcamDisplayStreamId;
                    if (this.profile.webcamDisplayStreamName !== null) this.displayStreamName = this.profile.webcamDisplayStreamName;
                }
            },
            updateWebCamOptions() {
                this.$root.$emit('updateBoardProfile', [
                    {id: "webcamDisplayOption", value: this.displayOption},
                    {id: "webcamDisplayStreamId", value: this.displayStreamId},
                    {id: "webcamDisplayStreamName", value: this.displayStreamName}
                ]);
            }
        }
    }
</script>
